'use strict';
import {isWebView, platform} from '../../core-utilities-implementation/device-services/DeviceServicesCordova';
import {isIosBuild} from "../../config/constants";


const angular = require('angular');
const {isFunction, isObject} = angular;

FilePickerFactory.$inject = [
  '$contextMenu',
  'DeviceServices',
  'FileDialog',
  'FileStack',
];

export function FilePickerFactory(
  $contextMenu,
  DeviceServices,
  FileDialog,
  FileStack,
) {
  return FilePicker;

  /**
   *
   * @param $scope
   * @param {Object} options
   * @param {Function} [options.getNewFilePath] - lazily return the file path to save the uploaded file under
   * @param {Function} [options.getNewFileName]
   * @param {Function} options.onSuccess
   * @param {Function} options.onError
   * @returns {{pickFile: pickFile, openCamera: openCamera}}
   * @constructor
   */
  function FilePicker($scope, options) {
    if (!isObject(options)) throw new Error('FilePickerFactory requires an options object specifying the onSuccess and onError functions to handle when a file is selected');

    return {
      pickFile: pickFile,
      openCamera: openCamera,
      openVideo: openVideo,
      uploadMobileIOSFile: uploadMobileIOSFile,
      pickLocalFile: pickLocalFile,
      showMobileUploadMenu: showMobileUploadMenu,
      showDesktopUploadMenu,
      supportsPickLocalFile: supportsPickLocalFile
    };

    // TODO: optionally show modal to let user crop uploaded image first.
    // TODO: (desktop) split uploads into local and cloud sources
    /**
     *
     * @param allowMultiple
     * @param {Object} filePickerOptions - See FileStack.pickFiles for the required options
     * @returns {*|void}
     */
    function showMobileUploadMenu(allowMultiple, filePickerOptions) {
      if (platform.isIOS) {
        return $contextMenu.show({
          titleMessageId: 'files.mobile.upload.title.label',
          cancelMessageId: 'defaults.context.cancel.label',
          actions: [
            {messageId: 'files.mobile.camera.label', action: openCamera.bind(null, null, null)},
            {messageId: 'files.mobile.video.label', action: openVideo.bind(null, null, null)},
            {messageId: 'files.mobile.select.label', action: FileStack.pickFile.bind(FileStack, filePickerOptions)},
            {messageId: 'files.mobile.select.label', action: uploadMobileIOSFile.bind(null, null, null)}
          ]
        });
      } else {
        return $contextMenu.show({
          titleMessageId: 'files.mobile.upload.title.label',
          cancelMessageId: 'defaults.context.cancel.label',
          actions: [
            {messageId: 'files.mobile.camera.label', action: openCamera.bind(null, null, null)},
            {messageId: 'files.mobile.video.label', action: openVideo.bind(null, null, null)},
            {messageId: 'files.mobile.select.label', action: FileStack.pickFile.bind(FileStack, filePickerOptions)}
            //{messageId: 'files.mobile.select.label', action: uploadMobileFile.bind(null, null, null)}
          ]
        });
      }
    }

    function showDesktopUploadMenu(allowAllTypes, allowMultiple) {
      return pickLocalFile(!!allowMultiple);
    }

    //TODO(files): revise the method signature after local file saving has been reworked to no longer rename things
    function pickFile(allowAllTypes, allowMultiple, filePickerOptions) {
      if (isWebView()) {
        return FileStack.pickFiles(filePickerOptions, {multiple: !!allowMultiple});
      } else {
        return pickLocalFile(allowMultiple);
      }
    }

    function pickLocalFile(allowMultiple) {
      if (!isWebView()) {
        //console.log('FilePicker.pickFile : open');
        const fd = new FileDialog();
        $scope.$on('$destroy', fd.dispose.bind(fd));

        return fd.open(allowMultiple).then(function (files) {
          //console.log('FilePicker.pickFile : open.then', files);
          try {
            if (files) {
              options.onSuccess(files);
            }
          } catch (error) {
            if (isFunction(options.onError)) {
              options.onError(error);
            }
          }

          return files;
        });
      }
    }

    function openCamera(filePath, fileName) {
      //console.log('open the camera', filePath, fileName);

      filePath = filePath ? filePath : options.getNewFilePath();
      fileName = fileName ? fileName : options.getNewFileName();

      if (DeviceServices.supportsCamera()) {
        //TODO(files): revise the method signature after local file saving has been reworked to no longer rename things
        return DeviceServices.capturePhoto(filePath, fileName)
          .then(result => options.onSuccess(result, /* fromCamera: */ true), options.onError);
      } else {
        return Promise.reject('FilePickerFactory.openCamera camera not supported on current platform')
      }
    }

    function openVideo(filePath, fileName) {
      //console.log('open the camera', filePath, fileName);

      filePath = filePath ? filePath : options.getNewFilePath();
      fileName = fileName ? fileName : options.getNewFileName();

      if (DeviceServices.supportsVideo()) {
        //TODO(files): revise the method signature after local file saving has been reworked to no longer rename things
        return DeviceServices.captureVideoStream(filePath, fileName)
          .then(result => options.onSuccess(result, /* fromCamera: */ false), options.onError);
      } else {
        return Promise.reject('FilePickerFactory.openVideo video not supported on current platform')
      }
    }

    function uploadMobileIOSFile(filePath, fileName) {
      filePath = filePath ? filePath : options.getNewFilePath();
      fileName = fileName ? fileName : options.getNewFileName();

      return DeviceServices.selectPhotoFromGallery(filePath, fileName, true)
        .then(result => {
          if (Array.isArray(result)) {
            result.forEach(item => options.onSuccess(item, /* fromCamera: */ true));
          } else {
            options.onSuccess(result, /* fromCamera: */ true);
          }
        })
        .catch(options.onError);
    }

    function supportsPickLocalFile() {
      return !isWebView();
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/file-dialog/FilePickerFactory.js